import React, { memo, PropsWithChildren } from 'react'

/** Stable wrapper for pane status-line DOM; avoids reconciling this node when only a child series row updates. */
const PaneMetaContainer = ({ children }: PropsWithChildren) => (
    <div className="pane-meta-container">{children}</div>
)

export default memo(PaneMetaContainer)
